import { Box, ListItem } from '@chakra-ui/react';
import { ListView } from 'components/molecules/ListView';
import { FC } from 'react';
import { useListStore } from '../../hooks';
import { ComponentListHeader } from './ComponentListHeader';
import { ComponentListItem } from './ComponentListItem';

type UseListStoreReturnType = ReturnType<typeof useListStore>;

type Props = {
  listItems: UseListStoreReturnType['releaseComponents'];
  handleEditOpenModal: UseListStoreReturnType['onOpenModal'];
};

export const ComponentListView: FC<Props> = ({
  listItems,
  handleEditOpenModal,
}) => (
  <>
    <Box m="20px 0 0 0">
      <ComponentListHeader />
    </Box>
    <ListView>
      {listItems.map((item) => (
        <ListItem key={item.id} listStyleType="none">
          <ComponentListItem
            item={item}
            handleClickRow={() => handleEditOpenModal(item)}
          />
        </ListItem>
      ))}
    </ListView>
  </>
);
